<template>
    <div class="ui-content dashboard">
        <div class="pad-l-r-30">
            <DashboardCoordinator />
        </div>
        <!-- <div v-if="user&&(roleIds.CO===user.role_id||roleIds.ID===user.role_id)" class="pad-l-r-30">
          <DashboardCoordinator />
         
        </div> -->
        <!-- <div v-else-if="user&&roleIds.ST===user.role_id" class="pad-l-r-30">
        
         
          <DashboardCoordinator />
        </div>
        <div v-else-if="user&&roleIds.PA===user.role_id" class="pad-l-r-30">
        
          <DashboardParent />
         
        </div> -->
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import DashboardCoordinator from '@/components/Dashboard/DashboardCoordinator.vue'
import DashboardParent from '@/components/Dashboard/DashboardParent.vue'
import DashboardStudent from '@/components/Dashboard/DashboardStudent.vue'
export default {
    name: 'Dashboard',
    components: {
        DashboardCoordinator,
        DashboardParent,
        DashboardStudent
    },

    mounted() {
        // this.me();
        //  this.getInstituteDetails();
        //  console.log('login');
         window.scrollTo(0, 0);
    },
    methods: {
        ...mapActions({
            me: "userStore/me",
            getInstituteDetails: "userStore/getInstituteDetails",
        })
    },
    computed: {
        ...mapState('userStore', ['user'])
    }
}
</script>
